export default __webpack_public_path__ + "static/media/Group 1000004959.ebbd3eca.png";